// extracted by css-extract-rspack-plugin
export default {"standardBox":"standardBox-ql7fpp"};